/* eslint-disable */

import { type SVGProps } from "react";
import { cn } from "../../lib/utils";

export function FilePdf({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("w-[1em] h-[1em]", className)}
      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      
<path d="M3 2C3 1.44772 3.44772 1 4 1H9L11 3L13 5V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V2Z" fill="#DEE2E8"></path>
<path d="M3 8H13V14C13 14.5523 12.5523 15 12 15H4C3.44772 15 3 14.5523 3 14V8Z" fill="#EF4444"></path>
<path d="M9 1L11 3L13 5H10C9.44772 5 9 4.55228 9 4V1Z" fill="#8B94A2"></path>

    </svg>
  );
}
